import { Link } from '@tanstack/react-router';
import useEmblaCarousel from 'embla-carousel-react';
import { WheelGesturesPlugin } from 'embla-carousel-wheel-gestures';

import { useDotButton } from '@/lib/hooks/use-embla-dots.ts';

type Props = {
	data: Array<{
		id: number;
		name: string;
		descriptionOrNull: string;
		photoUrl: string;
	}>;
};

export default function ServicesCarousel({ data = [] }: Props) {
	const [emblaRef, emblaApi] = useEmblaCarousel({ loop: false, dragFree: true, skipSnaps: true }, [
		WheelGesturesPlugin({ forceWheelAxis: 'x' }),
	]);
	const { scrollSnaps, selectedIndex, onDotButtonClick } = useDotButton(emblaApi);

	return (
		<div className="w-full flex flex-col gap-4 pl-4 max-sm:pl-0">
			<div className="embla max-lg:-ml-2 max-sm:m-0">
				<div className="embla_viewport" ref={emblaRef}>
					<div className="embla__container">
						{data?.map((service, index: number) => (
							<div
								className="embla__slide [--slide-size:95%] [--slide-spacing:1rem] [--slide-spacing-sm:1rem] [--slide-spacing-lg:1rem] max-sm:h-[230px] flex flex-col gap-4 max-md:gap-2 select-none"
								key={index}
							>
								<Link
									to={`/services/$serviceId`}
									params={{
										serviceId: `${service?.id}`,
									}}
									className="services-item-link relative h-full"
								>
									<span
										className="w-full h-full flex-1 rounded-xl overflow-hidden service-item"
										style={{
											viewTransitionName: `service-image-${service.id}`,
										}}
									>
										<span className="w-full h-full service-image">
											<img
												src={service.photoUrl}
												alt={service?.name}
												className="w-full h-full rounded-xl object-cover aspect-video"
											/>
										</span>

										<div className="service-item-info flex flex-col justify-center gap-4 absolute rounded-xl top-0 left-0 w-full h-full bg-gray-900/40 backdrop-blur-[1px] text-white p-4 z-10">
											<h2 className="text-white/90 text-center text-4xl max-2xl:text-3xl line-clamp-3">
												{service?.name}
											</h2>
										</div>
									</span>
								</Link>
							</div>
						))}
					</div>
				</div>
			</div>

			<div className="flex items-center justify-center gap-4 mb-4 max-md:hidden">
				<div className="flex items-center">
					{Array.from({ length: scrollSnaps?.length })
						.fill(null)
						?.map((_, i) => (
							<button
								key={`carousel_dot_${i}`}
								className="p-[4px] flex items-center justify-center w-[20px] h-[20px] shadow-none cursor-pointer"
								onClick={() => {
									onDotButtonClick(i);
								}}
							>
								<span
									className={`w-[12px] h-[12px] rounded-[100%] ${selectedIndex === i ? 'bg-[var(--primary)]' : 'bg-[var(--primary-light)]'}`}
								/>
							</button>
						))}
				</div>
			</div>
		</div>
	);
}
